import { MainParams } from './Main.props';
import { WrapperMain } from './Main.styles';

const Main = ({ children, ...props }: MainParams) => {
    return <WrapperMain {...props}>{children}</WrapperMain>;
};

export default Main;
